import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Card, CardBody, Row, Col, Button} from 'reactstrap';

import Form, {Text, ReactSelect, RadioGroup} from '@/Form';
import styles from '@/b2b/index.module.css';

import {ClientsCtx} from '@/b2b/contexts';
import {initialFields} from '@/b2b/pages/Clients/state';

import {
  buildRadioOptions,
  buildMultiSelectOptions,
} from '@/components/Form/formHelper';

const SearchBox = () => {
  const {t: tr} = useTranslation();
  const [{fields, queryParams}, dispatch] = useContext(ClientsCtx);

  const formData = {
    ...fields,
    manager: queryParams.manager,
    selectedProducerId: queryParams.selectedProducerId,
  };

  const setFormData = callback => {
    dispatch({type: 'changeFields', payload: callback()});
  };

  const handleSubmit = event => {
    event.preventDefault();
    dispatch({type: 'submit'});
  };

  const handleReset = () => {
    dispatch({type: 'changeFields', payload: initialFields});
  };

  return (
    <Form
      className={styles.search_box}
      stateHook={[formData, setFormData]}
      onSubmit={handleSubmit}
    >
      <Card>
        <CardBody className={styles.search_box_body}>
          <Row form>
            <Col md={10}>
              <Text name='manager' label={tr('consultant')} readOnly />
            </Col>
            <Col md={2}>
              <RadioGroup name='includedTeam' label={tr('included_team')}>
                {buildRadioOptions(
                  tr('selection:included_team'),
                  formData.includedTeam
                )}
              </RadioGroup>
            </Col>
          </Row>
          <Row form>
            <Col md={10}>
              <Text name='keywords' label={tr('clients:keywords')} />
            </Col>
            <Col md={2}>
              <ReactSelect
                name='excludePolicyStatus'
                label={tr('clients:exclude_policy_status')}
                multiple
                options={buildMultiSelectOptions(
                  tr('selection:exclude_policy_status')
                )}
                hideSelectedOptions={false}
                closeMenuOnSelect={false}
              />
            </Col>
          </Row>
          <Row form>
            <Col md={4}>
              <Text name='fundKeywords' label={tr('clients:fund_keywords')} />
            </Col>
            <Col md={6} className='pl-4'>
              <ReactSelect
                name='clientProductType'
                label={tr('clients:client_product_type')}
                multiple
                options={buildMultiSelectOptions(
                  tr('selection:b2b_product_type')
                )}
                hideSelectedOptions={false}
                closeMenuOnSelect={false}
              />
            </Col>
          </Row>

          <Row form>
            <Col md={10} />
            <Col md='1 text-right'>
              <Button size='sm' type='submit'>
                {tr('search')}
              </Button>
            </Col>
            <Col md={1}>
              <Button size='sm' onClick={handleReset} color='secondary'>
                {tr('reset')}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Form>
  );
};

export default SearchBox;
